import UdeskLocales from 'UdeskLocales';
import Udesk from 'Udesk';
import AdminUserGroupsViewComponent from './component';

export default class AdminUserGroupsViewRoute extends AdminUserGroupsViewComponent {
    model() {
        let params = Object.assign(
            {},
            this.props.match.params,
            Object.fromEntries(new URLSearchParams(this.props.location.search))
        );
        let modelPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(Udesk.business.apiPath.concatApiPath(`/userGroup/${params.id}`, this.props.sdkOptions)).then(
                resp => {
                    if(!resp.data) resp.data = {};
                    if (!resp.data.userList) resp.data.userList = [];
                    resolve(resp.data);
                },
                reason => {
                    Udesk.ui.notify.error(
                        reason.errorMsg || UdeskLocales.current.business.userGroup.loadUserGroupListError
                    );
                    reject(reason);
                }
            );
        });
        return {
            userGroup: modelPromise
        };
    }
}
